import React, { useRef, useState, useEffect } from "react";
import {
  Keyboard,
  View,
  Image,
  Button,
  Dimensions,
  StyleSheet,
  TextInput,
  KeyboardAvoidingView,
  TouchableWithoutFeedback,
  Platform,
} from "react-native";
import firebase from "firebase";
import "react-native-get-random-values";
import { v4 as uuidv4 } from "uuid";
import * as ImagePicker from "expo-image-picker";
import { Video, AVPlaybackStatus } from "expo-av";
import { useSelector, useDispatch } from "react-redux";
import { HeaderButtons, Item } from "react-navigation-header-buttons";
import { Ionicons } from "@expo/vector-icons";
import DefaultText from "../../../components/text/DefaultText";
import DefaultTextBold from "../../../components/text/DefaultTextBold";
import Colors from "../../../constants/Colors";
import CastButton from "../../../components/CastButton";
import Nft from "../../../models/nft";

const CreateArtScreen = (props) => {
  const popularNfts = useSelector((state) => state.nfts.popularNfts);
  const userNfts = useSelector((state) => state.userNfts.myNfts);

  const selectedNft = popularNfts[0];
  const video = useRef(null);
  const [status, setStatus] = React.useState({});
  const [image, setImage] = useState(null);
  const [imageFromLib, setImageFromLib] = useState(false);
  const [inputTitle, setInputTitle] = useState("");
  const [inputArtist, setInputArtist] = useState("");
  const [inputCollection, setInputCollection] = useState("");
  const [inputURL, setInputURL] = useState("");
  const onUpload = () => {};

  React.useLayoutEffect(() => {
    props.navigation.setOptions({
      headerRight: () => (
        <HeaderButtons HeaderButtonComponent={CastButton}>
          <Item
            title="upload"
            iconName={"cloud-upload-outline"}
            onPress={onSubmit}
          />
        </HeaderButtons>
      ),
    });
  }, [props.navigation, image]);

  useEffect(() => {
    (async () => {
      if (Platform.OS !== "web") {
        const { status } =
          await ImagePicker.requestMediaLibraryPermissionsAsync();
        if (status !== "granted") {
          alert("Sorry, we need camera roll permissions to make this work!");
        }
      }
    })();
  }, []);

  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.All,
      //   allowsEditing: true,
      //   aspect: [4, 3],
      quality: 1,
    });

    console.log(result);

    if (!result.cancelled) {
      setImage(result.uri);
      setImageFromLib(true);
    }
  };

  const onSubmit = () => {
    if (image) {
      const userId = firebase.auth().currentUser.uid;
      console.log(image);
      const fileExtension = image.split(".").pop();
      console.log("EXT: " + fileExtension);
      let uuid = uuidv4();
      const fileName = `${uuid}.${fileExtension}`;
      console.log(fileName);

      let storageRef = firebase.storage().ref();
      let mediaRef = storageRef.child(userId).child("upload").child(fileName);
      let uploadTask = mediaRef.put(image);

      uploadTask.put(image).on(
        "state_changed",
        (snapshot) => {
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log("Upload is running");
              break;
          }
        },
        (error) => {
          unsubscribe();
          console.log("image upload error: " + error.toString());
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            console.log("File available at", downloadURL);
          });
        }
      );

      const [inputTitle, setInputTitle] = useState("");
      const [inputArtist, setInputArtist] = useState("");
      const [inputCollection, setInputCollection] = useState("");
      const [inputURL, setInputURL] = useState("");
      new Nft(
        uuidv4(),
        inputTitle,
        image,
        inputArtist,
        inputCollection,
        "personal",
        "N/A",
        "N/A",
        "N/A"
      );
    }
  };
  const dismissKeyboard = () => {
    if (Platform.OS != "web") {
      Keyboard.dismiss();
    }
  };
  return (
    <KeyboardAvoidingView
      behavior="padding"
      keyboardVerticalOffset={50}
      style={styles.screen}
    >
      <TouchableWithoutFeedback onPress={dismissKeyboard}>
        <View style={styles.keyboardContainer}>
          {image == null ? (
            <View style={styles.videoContainer}>
              <Ionicons name="image-outline" size={24} color="white" />
              <Button
                title="Pick an image or video from camera roll"
                onPress={pickImage}
              />
            </View>
          ) : selectedNft.imageUrl.endsWith("mp4") ? (
            <Video
              ref={video}
              style={styles.video}
              source={{
                uri: selectedNft.imageUrl,
              }}
              useNativeControls
              resizeMode="cover"
              isLooping
              onPlaybackStatusUpdate={(status) => setStatus(() => status)}
              shouldPlay
            />
          ) : (
            <Image source={{ uri: image }} style={styles.image} />
          )}
          {!imageFromLib && (
            <View style={styles.details}>
              <DefaultTextBold>URL</DefaultTextBold>
              <TextInput
                placeholderTextColor="white"
                onChangeText={(text) => setInputURL(text)}
                value={inputURL}
                textAlign={"right"}
                style={styles.inputContainer}
                // onBlur={() => {
                //   setImage(inputURL);
                // }}
              />
            </View>
          )}
          <View style={styles.details}>
            <DefaultTextBold>Art Name</DefaultTextBold>
            <TextInput
              placeholderTextColor="white"
              onChangeText={(text) => setInputTitle(text)}
              value={inputTitle}
              textAlign={"right"}
              style={styles.inputContainer}
            />
          </View>
          <View style={styles.details}>
            <DefaultTextBold>Artist</DefaultTextBold>
            <TextInput
              placeholderTextColor="white"
              onChangeText={(text) => setInputArtist(text)}
              value={inputArtist}
              textAlign={"right"}
              style={styles.inputContainer}
            />
          </View>
          <View style={styles.details}>
            <DefaultTextBold>Collection</DefaultTextBold>
            <TextInput
              placeholderTextColor="white"
              onChangeText={(text) => setInputCollection(text)}
              value={inputCollection}
              textAlign={"right"}
              style={styles.inputContainer}
            />
          </View>
        </View>
      </TouchableWithoutFeedback>
    </KeyboardAvoidingView>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
  },
  keyboardContainer: {
    height: "100%",
  },
  image: {
    width: "100%",
    height: "60%",
    resizeMode: "contain",
  },
  videoContainer: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "60%",
  },

  video: {
    alignSelf: "center",
    width: "100%",
    height: Dimensions.get("window").height * 0.5,
  },
  buttons: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  scrollContainer: {},
  details: {
    flexDirection: "row",
    padding: 15,
    justifyContent: "space-between",
  },
  contractAddrTitle: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: 15,
  },
  contractAddrContent: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  hline: {
    borderBottomColor: Colors.primary,
    borderBottomWidth: 1,
    padding: 5,
  },
  title: {
    fontFamily: "open-sans-bold",
    fontSize: 22,
    textAlign: "center",
  },
  listItem: {
    marginVertical: 10,
    marginHorizontal: 20,
    borderColor: "#ccc",
    borderWidth: 1,
    padding: 10,
  },
  inputContainer: {
    color: "white",
    // height: 40,
    width: "50%",
    borderBottomWidth: 1,
    fontFamily: "JosefinSans_400Regular",
    borderColor: "white",
    // marginBottom: 55,
  },
});

export default CreateArtScreen;
